module.exports = __webpack_public_path__ + "assets/webgl/card_083_DE_L0.57e4fffd.jpg";